/**
 * Formats a phone number object into a readable string.
 *
 * If the country code is '+33' (France) and the number starts with '0',
 * the leading zero is removed before formatting.
 * The number is then grouped by pairs of digits separated by spaces.
 * If the phone number is not provided, returns '-'.
 *
 * @function
 *
 * @param {Object} phoneData - The phone data object.
 * @param {string} phoneData.country_code - The country code (e.g., '+33').
 * @param {string} phoneData.number - The phone number.
 * @returns {string} The formatted phone number or '-' if not available.
 */
export const formatPhoneNumber = (phoneData) => {
  if (!phoneData?.number) return '-';

  const countryCode = phoneData.country_code;

  // Strip non-digits then leading '0' (local-format prefix used in many countries)
  const digits = phoneData.number.replace(/\D/g, '').replace(/^0/, '');

  if (!digits) return '-';

  // Group in pairs; if odd digit count, first group takes 1 digit
  const formatted =
    digits.length % 2 !== 0
      ? `${digits[0]} ${digits
          .slice(1)
          .replace(/(\d{2})/g, '$1 ')
          .trim()}`
      : digits.replace(/(\d{2})/g, '$1 ').trim();

  return `${countryCode} ${formatted}`;
};
